import React, { useState, useRef, useEffect } from "react";
import userImgAvator from "./../assets/img/user.png";
import { API_SRC } from "../commons/Constants";
function NoteComponent({
  id,
  notes,
  handleChangeNote,
  handleSaveNote,
  isSavingNote,
  savedNotes,
}) {
  const [isEditing, setIsEditing] = useState(!notes[id]);
  const storedUser = JSON.parse(localStorage.getItem("user")) || {};
  const textareaRef = useRef(null);

  const autoResizeTextarea = () => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = "auto";
      textarea.style.height = `${textarea.scrollHeight}px`;
    }
  };

  useEffect(() => {
    if (isEditing) {
      const textarea = textareaRef.current;
      if (textarea) {
        textarea.focus(); // Set focus on the textarea
        // Move cursor to the end of the text
        textarea.setSelectionRange(textarea.value.length, textarea.value.length);
        autoResizeTextarea();
      }
    }
  }, [isEditing]);

  const handleNoteChange = (e) => {
    handleChangeNote(e, id);
    autoResizeTextarea();

  
  };

  const handleSaveClick = () => {
    handleSaveNote(id);
    setIsEditing(false);
 
  };

  return (
    <div
      className="row mt-1"
      style={{
        margin: "5px",
        width: "80%",
        padding: "5px",
      }}
    >
      <div className="col-log-1 col-md-1 col-sm-1 pt-2">
        <span
          className="rounded-circle bg-secondary text-white d-flex justify-content-center align-items-center"
          style={{ width: "50px", height: "50px" }}
        >
          <img
            src={storedUser.user.profile_img_url ? `${API_SRC}/${storedUser.user.profile_img_url}`
            : userImgAvator}
            alt="Profile"
            className="rounded-circle"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        </span>
      </div>

      <div className="col-log-10 col-md-11 col-sm-11 d-flex flex-column">
        {isEditing ? (
          <>
            <textarea
              ref={textareaRef}
              className="form-control mt-2 note-text-aria"
              placeholder="Add a note..."
              value={notes[id] || ""}
              onChange={handleNoteChange}
              style={{ overflow: "hidden", resize: "none" }}
            />
            <div className="align-self-end">
              <button
                className="btn btn-primary mt-2 btn-sm"
                onClick={handleSaveClick}
                disabled={isSavingNote}
              >
                {isSavingNote
                  ? savedNotes[id]
                    ? "Updating..."
                    : "Saving..."
                  : savedNotes[id]
                  ? "Update"
                  : "Save"}
              </button>
            </div>
          </>
        ) : (
          <>
            <p
              className="mt-2 note-text-aria"
              style={{
                whiteSpace: "pre-wrap",
                padding: "5px 15px",
                color: "grey",
                border: "1px solid grey",
                borderRadius: "5px",
                minHeight: "60px",
              }}
            >
              {notes[id] || "No notes added yet."}
            </p>
            <div className="align-self-end">
              <button
                className="btn btn-primary mt-2 btn-sm"
                onClick={() => setIsEditing(true)}
              >
                Edit
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default NoteComponent;
